import React from 'react';
import { Button } from '@dotcom/crown-ui';
import styles from '../delete-images-confirmation-dialog.module.scss';
import { DeleteImagesDialogButtonsProps } from '../delete-images-dialog-types';

export const Buttons = ({
  onConfirm,
  onClose,
  actionButtonText = 'Delete',
  cancelButtonText = 'Back',
}: DeleteImagesDialogButtonsProps): React.ReactElement => {
  const deleteButton = (
    <Button onClick={() => onConfirm()} variant="primary" testId={'delete-confirmation-action-button'}>
      {actionButtonText}
    </Button>
  );

  const backButton = (
    <Button variant="secondary" onClick={() => onClose()} testId={'delete-confirmation-cancel-button'}>
      {cancelButtonText}
    </Button>
  );

  return (
    <div className={styles.buttonsContainer}>
      {deleteButton}
      {backButton}
    </div>
  );
};
